export enum RouterQueryParams {
  cid = 'cid',
  lnid = 'lnid',
  partyId = 'partyId',
  viewAs = 'viewAs',
  id = 'ID',
  idg = 'IDG',
}
